import * as React from 'react';
import MsDyn365, { IActionContext } from '@msdyn365-commerce/core';
import { GaPayload, pushGoogleAnalyticsEvent } from './pushGoogleAnalyticsEvent';

let lastCached = '';

const useGoogleAnalytics = (payload?: GaPayload, actionContext?: IActionContext, deps?: React.DependencyList | undefined) => {
    const isBrowser = MsDyn365.isBrowser;

    const cacheKey = React.useMemo(() => {
        if (payload?.event === 'view_item' && payload.ecommerce?.items) {
            return payload.ecommerce?.items[0]?.item_id;
        } else if (payload?.event === 'purchase') {
            return payload.ecommerce?.transaction_id;
        } else if (payload?.event === 'begin_checkout' && payload.ecommerce?.items) {
            return payload.ecommerce?.items.map(i => i.item_id).join(',');
        }

        return '';
    }, [payload]);

    if (cacheKey) {
        // skip if the event is unrecognized
        lastCached = cacheKey;
    }

    process.env.NODE_ENV === 'development' && console.log('useGoogleAnalytics', 'cacheKey', cacheKey);

    React.useEffect(() => {
        if (isBrowser) {
            void pushGoogleAnalyticsEvent(payload, actionContext);
        }
    }, [isBrowser, cacheKey || lastCached, ...(deps ?? [])]);
};

export { useGoogleAnalytics };
